import styled from '@emotion/styled';

// Styled components for current location button
export const CurrentLocationButton = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 12px 14px;
  color: black;
  background-color: #f7f9fc;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  margin-top: 12px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #edf2f7;
    border-color: #5c6ac4;
    transform: translateY(-1px);
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  &:active {
    transform: translateY(0);
    box-shadow: none;
  }
`;

export const LocationIconWrapper = styled.span<{ $isLoading?: boolean }>`
  display: inline-flex;
  margin-right: 10px;
  color: #5c6ac4;
  animation: ${props => (props.$isLoading ? 'pulse 1.5s infinite ease-in-out' : 'none')};

  @keyframes pulse {
    0% {
      opacity: 0.6;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.6;
    }
  }
`;

export const LocationText = styled.span`
  color: white;
  font-size: 15px;
  font-weight: 700;
  display: flex;
  align-items: center;

  .loading-dots {
    display: inline-flex;
    margin-left: 4px;
  }

  .loading-dots span {
    width: 3px;
    height: 3px;
    margin: 0 1px;
    background-color: #333;
    border-radius: 50%;
    display: inline-block;
    animation: loadingDots 1.4s infinite ease-in-out both;
  }

  .loading-dots span:nth-of-type(1) {
    animation-delay: -0.32s;
  }

  .loading-dots span:nth-of-type(2) {
    animation-delay: -0.16s;
  }

  @keyframes loadingDots {
    0%,
    80%,
    100% {
      transform: scale(0);
    }
    40% {
      transform: scale(1);
    }
  }
`;
